export const inputLabelTheme = {
  root: {
    overflow: 'inherit',
  },
  outlined: {
    '&.MuiInputLabel-shrink': {
      opacity: '1!important',
    },
    '&.MuiInputLabel-animated': {
      lineHeight: 1,
      opacity: 0.5,
    },
  },
}
